import React, { useState } from "react";
import { IConfiguracao } from "../interfaces/IConfiguracao";
import IPreAlertaQtdPendente from "../interfaces/IPreAlertaQtdPendente";
import IPreAlertaUnitizador from "../interfaces/IPreAlertaUnitizador";
import IPreAlertaResumo from "../interfaces/IPreAlertaResumo";
import { IDimensoes } from "../interfaces/IDimensoes";
import { CEPZERO } from "../utils/Constants";

type AlertaExpedicaoProviderProps = {
    children: React.ReactNode; // 👈️ type children
  };
  
  type AlertaExpedicaoContextType = {
    key: string
    setKey: React.Dispatch<React.SetStateAction<string>>
    keyTabTipoCarga: string,
    setKeyTabTipoCarga: React.Dispatch<React.SetStateAction<string>>,
    codSroUnidadeOrigem: string | undefined,
    setCodSroUnidadeOrigem: React.Dispatch<React.SetStateAction<string | undefined>>,
    configuracao: IConfiguracao,
    setConfiguracao: React.Dispatch<React.SetStateAction<IConfiguracao>>
    dimensoes: IDimensoes,
    setDimensoes:React.Dispatch<React.SetStateAction<IDimensoes>>
    dataSelecionada: string
    setDataSelecionada: React.Dispatch<React.SetStateAction<string>>
    showSpinner: boolean,
    setShowSpinner: React.Dispatch<React.SetStateAction<boolean>>,
    resumoAlerta: IPreAlertaResumo[],
    setResumoAlerta: React.Dispatch<React.SetStateAction<IPreAlertaResumo[]>>,
    iPreAlertaUnitizador: IPreAlertaUnitizador | null,
    setIPreAlertaUnitizador: React.Dispatch<React.SetStateAction<IPreAlertaUnitizador | null>>
    listaExpedicaoPendente: IPreAlertaQtdPendente[],
    setListaExpedicaoPendente: React.Dispatch<React.SetStateAction<IPreAlertaQtdPendente[]>>,
    listaUnitizadorUnidadeData: IPreAlertaUnitizador[],
    setListaUnitizadorUnidadeData: React.Dispatch<React.SetStateAction<IPreAlertaUnitizador[]>>,
    tipoConsultaNaApi: string,
    setTipoConsultaNaApi: React.Dispatch<React.SetStateAction<string>>
  }
  
  //Valor default do contexto
  const DEFAULT_VALUE = {
    key: 'resumo',
    setKey: () => 'resumo',
    keyTabTipoCarga: 'urg', 
    setKeyTabTipoCarga: () => 'urg',
    codSroUnidadeOrigem: CEPZERO,
    setCodSroUnidadeOrigem: () => CEPZERO,
    configuracao: { rowResClicada: 0, rowUnitClicada: 0, dataSelecionada: '' },
    setConfiguracao: () => {}, //função de inicialização
    dimensoes: { width: 0, height: 0},
    setDimensoes:()=>{},
    dataSelecionada: '1900-01-01',
    setDataSelecionada: ()=> '1900-01-01',
    showSpinner: true,
    setShowSpinner: () => true,
    resumoAlerta: [],
    setResumoAlerta: () => [],
    iPreAlertaUnitizador: null,
    setIPreAlertaUnitizador: () => {},
    listaExpedicaoPendente: [],
    setListaExpedicaoPendente: () => [],
    listaUnitizadorUnidadeData:[],
    setListaUnitizadorUnidadeData: () => [],
    tipoConsultaNaApi: 'todos',
    setTipoConsultaNaApi: () => 'todos',
  };

export const AlertaExpedicaoContext = React.createContext<AlertaExpedicaoContextType>(DEFAULT_VALUE);

const AlertaExpedicaoProvider: React.FC<AlertaExpedicaoProviderProps> = ({ children }) => {

   const [key, setKey] = useState<string>('resumo');
   const [keyTabTipoCarga, setKeyTabTipoCarga] = useState<string>('urg');
   const [codSroUnidadeOrigem, setCodSroUnidadeOrigem] = useState<string | undefined>(CEPZERO);
   const [configuracao, setConfiguracao] = useState<IConfiguracao>({ rowResClicada: 0, rowUnitClicada: 0 });
   const [dimensoes, setDimensoes] = useState<IDimensoes>({ width: 0, height: 0});
   const [dataSelecionada, setDataSelecionada] = useState<string>('1900-01-01');
   const [showSpinner, setShowSpinner] = useState<boolean>(true);
   const [resumoAlerta, setResumoAlerta] = useState<IPreAlertaResumo[]>([]);
   const [listaExpedicaoPendente, setListaExpedicaoPendente] = useState<IPreAlertaQtdPendente[]>([]);
   const [listaUnitizadorUnidadeData, setListaUnitizadorUnidadeData] = useState<IPreAlertaUnitizador[]>([]);
   const [iPreAlertaUnitizador, setIPreAlertaUnitizador] = useState<IPreAlertaUnitizador | null>(null);
   const [tipoConsultaNaApi, setTipoConsultaNaApi] = useState<string>('todos');

   return (
        <AlertaExpedicaoContext.Provider value={{
            key, setKey,
            keyTabTipoCarga, setKeyTabTipoCarga,
            codSroUnidadeOrigem, setCodSroUnidadeOrigem,
            configuracao, setConfiguracao,
            dimensoes, setDimensoes,
            dataSelecionada, setDataSelecionada,
            showSpinner, setShowSpinner,
            resumoAlerta, setResumoAlerta,
            iPreAlertaUnitizador, setIPreAlertaUnitizador,
            listaExpedicaoPendente, setListaExpedicaoPendente,
            listaUnitizadorUnidadeData, setListaUnitizadorUnidadeData,
            tipoConsultaNaApi, setTipoConsultaNaApi}}>
        {children}
        </AlertaExpedicaoContext.Provider>
  )
}

export default AlertaExpedicaoProvider;